<template>
  <div
    class="entries"
  >
    <div
      v-if="moduleCategories.length"
      class="modules"
    >
      <MenuCategory
        v-for="category in visibleModuleCategories"
        :key="category.name"
        :module-category="category"
        :event-bus="menuEventBus"
      />
    </div>
    <div v-else>
      <MenuLoader />
    </div>
  </div>
</template>

<script>
import MenuLoader from '@/components/layout/navigation/menu/loader/MenuLoader.vue';
import MenuCategory from './level1/MenuCategory.vue';

export default {
  name: 'MainMenuEntries',
  components: { MenuLoader, MenuCategory },
  props: {
    moduleCategories: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    menuEventBus() {
      return this.$store.getters.menuEventBus;
    },
    visibleModuleCategories() {
      return this.moduleCategories.filter((moduleCategory) => moduleCategory.showInMenu);
    },
  },
};
</script>

<style lang="scss" scoped>
  .entries {
    .modules {
      padding: 0 15px 25px 15px;
      user-select: none;
      display: grid;
      grid-auto-rows: max-content;
      grid-gap: 8px;
    }
  }
</style>
